import { type User } from '../domain/User'

export type RawUser = {
  uuid: string
  email: string
  first_name: string
  last_name: string
}

export function mapApiToUser(rawUser: RawUser): User {
  return {
    uuid: rawUser.uuid,
    email: rawUser.email,
    firstName: rawUser.first_name,
    lastName: rawUser.last_name,
  }
}
